import React, { useEffect, useRef, useState } from 'react'
import PageHeader from 'components/pageHeader';
import './userBasicProfileV3.css';
import { connect } from 'react-redux'
import UserProfileV3 from './userProfileV3';
import { useHistory, useLocation } from 'react-router';
import { getStaffProfile } from 'actions/userManagementV3';
import PageDataLoader from 'components/pageDataLoader';
import UserProfileAttendanceDetailsV3 from './userProfileAttendanceDetailsV3';





const UserBasicProfileV3 = ({ userRowDetails, getStaffProfile }) => {
    const [specificUserProfile, setSpecificUserProfile] = useState(null);

    const bodyStyle = {
        backgroundColor: "#FAFAFA",
        width: " calc(100% + 30px)",
        height: "100%",
        margin: "-20px",
        padding: "20px 10px 15px 10px",
        // overflow: "auto"
    }

    

    const [pageLoader, togglePageLoader] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const history = useHistory()
    const location = useLocation();

    useEffect(() => {
        togglePageLoader(true)
        getStaffProfile(userRowDetails?.id, (response, error) => {
            togglePageLoader(false);
            if (response) {
                const profile = response?.data ?? response;
                // roles comes back as [{ id, userId, role }], but the rest of
                // this page (UserProfileV3 etc.) reads a flat `role` string.
                setSpecificUserProfile({ ...profile, role: profile?.roles?.[0]?.role || profile?.role });
            }
        });
    }, [])
console.log("userRowDetails",userRowDetails);

    useEffect(() => {
        const handleScroll = () => {
            const div = document.getElementById('scrollableDiv');
            if (div) {
                const scrollTop = div.scrollTop;
                console.log({ scrollTop });
                const scrollHeight = div.scrollHeight;
                const clientHeight = div.clientHeight;

                if (scrollTop > 0 && scrollHeight > clientHeight) {
                    setIsScrolled(true);
                } else if (scrollTop == 0) {
                    setIsScrolled(false);
                }

            }
        };
        const div = document.getElementById('scrollableDiv');
        if (div) {
            div.addEventListener('scroll', handleScroll);
        }
        return () => {
            const div = document.getElementById('scrollableDiv');
            if (div) {
                div.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);



    useEffect(() => {
        const div = document.getElementById('scrollableDiv');
        if (isScrolled) {
            setTimeout(() => {
                div.scrollTop = 1
            }, 900)
        }
    }, [isScrolled]);

    return (
        <div style={{ ...bodyStyle, }}>
            <div style={{ marginBottom: "45px" }}>
                <PageHeader
                    onBackPress={() => {
                        const basePath = location.pathname.startsWith('/user-management-v2') ? '/user-management-v2' : '/user-management';
                        history.push({
                            pathname: `${basePath}/staffs`,
                            state: {
                                key: true,
                            }
                        })
                    }}
                    title={`${userRowDetails?.name}'s profile`} />
            </div>

            <div style={{ height: '100%', }}>
                    <UserProfileV3 userRowDetails={userRowDetails} specificUserProfile={specificUserProfile} isScrolled={isScrolled}/>
                <div className={`user-profile-card scroll-bar-universal ${(!isScrolled ? 'leads-collapse-height-v3' : 'leads-expand-height-v3')}`} id='scrollableDiv' >
                    <UserProfileAttendanceDetailsV3 specificUserProfile={specificUserProfile} isScrolled={isScrolled} setIsScrolled={setIsScrolled} />
                </div>

            </div>

            <PageDataLoader visible={pageLoader} />
        </div>
    )
}

const mapStateToProps = (state) => {

    const { userRowDetails } = state.userManagementV2;
    return {
        userRowDetails
    }
}

const mapDispatchToProps = (dispatch) => ({
    getStaffProfile: (id, callback) => dispatch(getStaffProfile(id, callback)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserBasicProfileV3);
